import { render, staticRenderFns } from "./updownlist.vue?vue&type=template&id=045236f3&scoped=true&"
import script from "./updownlist.vue?vue&type=script&lang=js&"
export * from "./updownlist.vue?vue&type=script&lang=js&"
import style0 from "./updownlist.vue?vue&type=style&index=0&id=045236f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045236f3",
  null
  
)

export default component.exports